module.exports = __webpack_public_path__ + "static/img/finger.be89d932.png";